const ForbiddenMessageStatusTypes = {
    ACCOUNT_NOT_CONFIRMED: "ACCOUNT_NOT_CONFIRMED",
    ACCOUNT_NOT_CONFIRMED_SENT_NEW_MAIL: "ACCOUNT_NOT_CONFIRMED_SENT_NEW_MAIL",
    DEVICE_LIMIT_REACHED: "DEVICE_LIMIT_REACHED",
    INVALID_VIDEO_SESSION: "INVALID_VIDEO_SESSION",
} as const;
export type ForbiddenMessageStatusTypes = keyof typeof ForbiddenMessageStatusTypes;

export const ForbiddenException = (messageCode: ForbiddenMessageStatusTypes | string, message: string) => ({
    error: new Error(message),
    status: messageCode,
    code: 403
})